<template>
    <div class="pb2-sidebar">
        <div v-if="store.mode.value === 'edit'" class="pb2-sidebar__tabs" role="tablist">
            <button
                id="pb2-sidebar-tab-blocks"
                type="button"
                role="tab"
                class="pb2-sidebar__tab"
                :class="{ 'pb2-sidebar__tab--active': tab === 'blocks' }"
                :aria-selected="tab === 'blocks'"
                aria-controls="pb2-sidebar-panel"
                @click="tab = 'blocks'"
            >
                {{ t('tab_blocks') }}
            </button>
            <button
                id="pb2-sidebar-tab-outline"
                type="button"
                role="tab"
                class="pb2-sidebar__tab"
                :class="{ 'pb2-sidebar__tab--active': tab === 'outline' }"
                :aria-selected="tab === 'outline'"
                aria-controls="pb2-sidebar-panel"
                @click="tab = 'outline'"
            >
                {{ t('outline') }}
            </button>
        </div>

        <div
            id="pb2-sidebar-panel"
            role="tabpanel"
            :aria-labelledby="tab === 'blocks' ? 'pb2-sidebar-tab-blocks' : 'pb2-sidebar-tab-outline'"
        >
            <PalettePanel v-if="tab === 'blocks' && store.mode.value === 'edit'" />
            <OutlinePanel v-else />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useBuilderT } from '@src/Common/Builder/host';
import OutlinePanel from '@src/Common/Builder/Outline/OutlinePanel.vue';
import PalettePanel from '@src/Common/Builder/Sidebar/PalettePanel.vue';
import { useBuilderStore } from '@src/Common/Builder/useBuilderStore';
import { useSidebarTab } from '@src/Common/Builder/Sidebar/useSidebarTab';

const t = useBuilderT();

const store = useBuilderStore();
const tab = useSidebarTab();
</script>

<style scoped>
.pb2-sidebar {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.pb2-sidebar__tabs {
    display: flex;
    gap: 0.25rem;
    border-bottom: 1px solid var(--pb2-border, #e4e4e7);
}

.pb2-sidebar__tab {
    padding: 0.25rem 0.5rem;
    font-size: 0.6875rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: var(--pb2-muted, #a1a1aa);
    background: none;
    border: 0;
    border-bottom: 2px solid transparent;
    cursor: pointer;
}

.pb2-sidebar__tab--active {
    color: var(--pb2-accent, #2563eb);
    border-bottom-color: var(--pb2-accent, #2563eb);
}
</style>
